/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
// tslint:disable:no-var-requires
import { mapValues } from 'lodash-es'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

const ReactTimeAgo = require('react-timeago').default
const strings = {
  de: require('react-timeago/lib/language-strings/de').default,
  en: require('react-timeago/lib/language-strings/en').default,
}
const buildFormatter =
  require('react-timeago/lib/formatters/buildFormatter').default

const formatters = mapValues(strings, buildFormatter)

export interface TimeAgoProps {
  date: Date | number | string
  live?: boolean
  title?: any
}
export const TimeAgo = ({
  date,
  title: maybeTitle,
  ...props
}: TimeAgoProps) => {
  const { i18n } = useTranslation()
  const formatter = React.useMemo(
    () => formatters[i18n.language] || formatters.de,
    [i18n.language]
  )
  const title = React.useMemo(() => {
    if (maybeTitle) {
      return maybeTitle
    }
    if (date instanceof Date) {
      return date.toLocaleString()
    } else if (typeof date === 'string') {
      return new Date(Date.parse(date)).toLocaleString()
    } else {
      return new Date(date).toLocaleString()
    }
  }, [date, maybeTitle])

  return (
    <ReactTimeAgo
      css={css`
        cursor: help;
      `}
      date={date}
      title={title}
      {...props}
      formatter={formatter}
    />
  )
}
